import React from "react";
import { useSelector } from "react-redux";
import PropTypes from "prop-types";
import { useSecurity } from "~/components/Hooks";
import { SelectTrackingRecordDate } from "~/components/SelectDate/SelectTrackingRecordDate";
import { getConfigOption } from "~/store/selectors/selector.configOptions";
import { getProjectById } from "~/store/selectors/selector.projects";
import { getTimeRecordById } from "~/store/selectors/selector.timeRecords";

export const SelectTimeRecordDate = ({ timeRecordId, onChange }) => {
  const can = useSecurity();

  const timeRecord = useSelector((state) => getTimeRecordById(state, timeRecordId));

  const project = useSelector((state) => getProjectById(state, timeRecord.project_id));

  const canTrackForOtherUsers = can(["can_track_time_for_others"], project);

  const backtrackMaxDays = useSelector((state) => getConfigOption(state, "backtrack_time_max_days"));

  return (
    <SelectTrackingRecordDate
      backtrackMaxDays={backtrackMaxDays}
      canTrackForOther={canTrackForOtherUsers}
      startDate={timeRecord?.created_on}
      selectedDate={timeRecord?.record_date}
      onChange={onChange}
    />
  );
};

SelectTimeRecordDate.propTypes = {
  timeRecordId: PropTypes.number.isRequired,
  onChange: PropTypes.func,
};
